import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home key="pt" />,
  },
  {
    path: "/en",
    element: <Home key="en" lang="en" />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
